var M = Object.defineProperty;
var G = (t, e, r) => e in t ? M(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var y = (t, e, r) => G(t, typeof e != "symbol" ? e + "" : e, r);
const B = "application/json", F = "Content-Type", v = Symbol(), H = Symbol();
function D(t = {}) {
  var e;
  return (e = Object.entries(t).find(([r]) => r.toLowerCase() === F.toLowerCase())) === null || e === void 0 ? void 0 : e[1];
}
function L(t) {
  return /^application\/.*json.*/.test(t);
}
const C = function(t, e, r = !1) {
  return Object.entries(e).reduce((s, [n, i]) => {
    const a = t[n];
    return Array.isArray(a) && Array.isArray(i) ? s[n] = r ? [...a, ...i] : i : typeof a == "object" && typeof i == "object" ? s[n] = C(a, i, r) : s[n] = i, s;
  }, { ...t });
}, w = {
  // Default options
  options: {},
  // Error type
  errorType: "text",
  // Polyfills
  polyfills: {
    // fetch: null,
    // FormData: null,
    // URL: null,
    // URLSearchParams: null,
    // performance: null,
    // PerformanceObserver: null,
    // AbortController: null,
  },
  polyfill(t, e = !0, r = !1, ...s) {
    const n = this.polyfills[t] || (typeof self < "u" ? self[t] : null) || (typeof global < "u" ? global[t] : null);
    if (e && !n)
      throw new Error(t + " is not defined");
    return r && n ? new n(...s) : n;
  }
};
function q(t, e = !1) {
  w.options = e ? t : C(w.options, t);
}
function z(t, e = !1) {
  w.polyfills = e ? t : C(w.polyfills, t);
}
function W(t) {
  w.errorType = t;
}
const J = (t) => (e) => t.reduceRight((r, s) => s(r), e) || e;
class x extends Error {
}
const Y = (t) => {
  const e = /* @__PURE__ */ Object.create(null);
  t = t._addons.reduce((o, c) => c.beforeRequest && c.beforeRequest(o, t._options, e) || o, t);
  const { _url: r, _options: s, _config: n, _catchers: i, _resolvers: a, _middlewares: u, _addons: l } = t, h = new Map(i), p = C(n.options, s);
  let S = r;
  const g = J(u)((o, c) => (S = o, n.polyfill("fetch")(o, c)))(r, p), f = new Error(), E = g.catch((o) => {
    throw { [v]: o };
  }).then((o) => {
    if (!o.ok) {
      const c = new x();
      if (c.cause = f, c.stack = c.stack + `
CAUSE: ` + f.stack, c.response = o, c.url = S, o.type === "opaque")
        throw c;
      return o.text().then((d) => {
        var _;
        if (c.message = d, n.errorType === "json" || ((_ = o.headers.get("Content-Type")) === null || _ === void 0 ? void 0 : _.split(";")[0]) === "application/json")
          try {
            c.json = JSON.parse(d);
          } catch {
          }
        throw c.text = d, c.status = o.status, c;
      });
    }
    return o;
  }), O = (o) => o.catch((c) => {
    const d = c.hasOwnProperty(v), _ = d ? c[v] : c, b = (_ == null ? void 0 : _.status) && h.get(_.status) || h.get(_ == null ? void 0 : _.name) || d && h.has(v) && h.get(v);
    if (b)
      return b(_, t);
    const j = h.get(H);
    if (j)
      return j(_, t);
    throw _;
  }), m = (o) => (c) => /* If a callback is provided, then callback with the body result otherwise return the parsed body itself. */ O(o ? E.then((d) => d && d[o]()).then((d) => c ? c(d) : d) : E.then((d) => c ? c(d) : d)), I = {
    _wretchReq: t,
    _fetchReq: g,
    _sharedState: e,
    res: m(null),
    json: m("json"),
    blob: m("blob"),
    formData: m("formData"),
    arrayBuffer: m("arrayBuffer"),
    text: m("text"),
    error(o, c) {
      return h.set(o, c), this;
    },
    badRequest(o) {
      return this.error(400, o);
    },
    unauthorized(o) {
      return this.error(401, o);
    },
    forbidden(o) {
      return this.error(403, o);
    },
    notFound(o) {
      return this.error(404, o);
    },
    timeout(o) {
      return this.error(408, o);
    },
    internalError(o) {
      return this.error(500, o);
    },
    fetchError(o) {
      return this.error(v, o);
    }
  }, A = l.reduce((o, c) => ({
    ...o,
    ...typeof c.resolver == "function" ? c.resolver(o) : c.resolver
  }), I);
  return a.reduce((o, c) => c(o, t), A);
}, Q = {
  _url: "",
  _options: {},
  _config: w,
  _catchers: /* @__PURE__ */ new Map(),
  _resolvers: [],
  _deferred: [],
  _middlewares: [],
  _addons: [],
  addon(t) {
    return { ...this, _addons: [...this._addons, t], ...t.wretch };
  },
  errorType(t) {
    return {
      ...this,
      _config: {
        ...this._config,
        errorType: t
      }
    };
  },
  polyfills(t, e = !1) {
    return {
      ...this,
      _config: {
        ...this._config,
        polyfills: e ? t : C(this._config.polyfills, t)
      }
    };
  },
  url(t, e = !1) {
    if (e)
      return { ...this, _url: t };
    const r = this._url.split("?");
    return {
      ...this,
      _url: r.length > 1 ? r[0] + t + "?" + r[1] : this._url + t
    };
  },
  options(t, e = !1) {
    return { ...this, _options: e ? t : C(this._options, t) };
  },
  headers(t) {
    const e = t ? Array.isArray(t) ? Object.fromEntries(t) : "entries" in t ? Object.fromEntries(t.entries()) : t : {};
    return { ...this, _options: C(this._options, { headers: e }) };
  },
  accept(t) {
    return this.headers({ Accept: t });
  },
  content(t) {
    return this.headers({ [F]: t });
  },
  auth(t) {
    return this.headers({ Authorization: t });
  },
  catcher(t, e) {
    const r = new Map(this._catchers);
    return r.set(t, e), { ...this, _catchers: r };
  },
  catcherFallback(t) {
    return this.catcher(H, t);
  },
  resolve(t, e = !1) {
    return { ...this, _resolvers: e ? [t] : [...this._resolvers, t] };
  },
  defer(t, e = !1) {
    return {
      ...this,
      _deferred: e ? [t] : [...this._deferred, t]
    };
  },
  middlewares(t, e = !1) {
    return {
      ...this,
      _middlewares: e ? t : [...this._middlewares, ...t]
    };
  },
  fetch(t = this._options.method, e = "", r = null) {
    let s = this.url(e).options({ method: t });
    const n = D(s._options.headers), i = this._config.polyfill("FormData", !1), a = typeof r == "object" && !(i && r instanceof i) && (!s._options.headers || !n || L(n));
    return s = r ? a ? s.json(r, n) : s.body(r) : s, Y(s._deferred.reduce((u, l) => l(u, u._url, u._options), s));
  },
  get(t = "") {
    return this.fetch("GET", t);
  },
  delete(t = "") {
    return this.fetch("DELETE", t);
  },
  put(t, e = "") {
    return this.fetch("PUT", e, t);
  },
  post(t, e = "") {
    return this.fetch("POST", e, t);
  },
  patch(t, e = "") {
    return this.fetch("PATCH", e, t);
  },
  head(t = "") {
    return this.fetch("HEAD", t);
  },
  opts(t = "") {
    return this.fetch("OPTIONS", t);
  },
  body(t) {
    return { ...this, _options: { ...this._options, body: t } };
  },
  json(t, e) {
    const r = D(this._options.headers);
    return this.content(e || L(r) && r || B).body(JSON.stringify(t));
  }
};
function P(t = "", e = {}) {
  return { ...Q, _url: t, _options: e };
}
P.default = P;
P.options = q;
P.errorType = W;
P.polyfills = z;
P.WretchError = x;
const X = () => ({
  beforeRequest(t, e, r) {
    const s = t._config.polyfill("AbortController", !1, !0);
    !e.signal && s && (e.signal = s.signal);
    const n = {
      ref: null,
      clear() {
        n.ref && (clearTimeout(n.ref), n.ref = null);
      }
    };
    return r.abort = {
      timeout: n,
      fetchController: s
    }, t;
  },
  wretch: {
    signal(t) {
      return { ...this, _options: { ...this._options, signal: t.signal } };
    }
  },
  resolver: {
    setTimeout(t, e = this._sharedState.abort.fetchController) {
      const { timeout: r } = this._sharedState.abort;
      return r.clear(), r.ref = setTimeout(() => e.abort(), t), this;
    },
    controller() {
      return [this._sharedState.abort.fetchController, this];
    },
    onAbort(t) {
      return this.error("AbortError", t);
    }
  }
});
function k(t) {
  return typeof t < "u" ? t : "";
}
const Z = (t, e, r, s, n) => {
  let i;
  if (typeof e == "string")
    i = e;
  else {
    const u = n.polyfill("URLSearchParams", !0, !0);
    for (const l in e) {
      const h = e[l];
      if (!(s && h == null))
        if (e[l] instanceof Array)
          for (const p of h)
            u.append(l, k(p));
        else
          u.append(l, k(h));
    }
    i = u.toString();
  }
  const a = t.split("?");
  return i ? r || a.length < 2 ? a[0] + "?" + i : t + "&" + i : r ? a[0] : t;
}, $ = {
  wretch: {
    query(t, e = !1, r = !1) {
      return { ...this, _url: Z(this._url, t, e, r, this._config) };
    }
  }
}, K = (t, e) => e.skipDedupe || e.method !== "GET", V = (t, e) => e.method + "@" + t, tt = (t) => t.clone(), et = ({ skip: t = K, key: e = V, resolver: r = tt } = {}) => {
  const s = /* @__PURE__ */ new Map();
  return (n) => (i, a) => {
    if (t(i, a))
      return n(i, a);
    const u = e(i, a);
    if (!s.has(u))
      s.set(u, []);
    else
      return new Promise((l, h) => {
        s.get(u).push([l, h]);
      });
    try {
      return n(i, a).then((l) => (s.get(u).forEach(([h]) => h(r(l))), s.delete(u), l)).catch((l) => {
        throw s.get(u).forEach(([h, p]) => p(l)), s.delete(u), l;
      });
    } catch (l) {
      return s.delete(u), Promise.reject(l);
    }
  };
}, rt = (t, e) => t * e, st = (t) => t && t.ok, ot = ({ delayTimer: t = 500, delayRamp: e = rt, maxAttempts: r = 10, until: s = st, onRetry: n = null, retryOnNetworkError: i = !1, resolveWithLatestResponse: a = !1, skip: u } = {}) => (l) => (h, p) => {
  let S = 0;
  if (u && u(h, p))
    return l(h, p);
  const g = (f, E) => Promise.resolve(s(f, E)).then((O) => O ? f && a ? f : E ? Promise.reject(E) : f : (S++, !r || S <= r ? new Promise((m) => {
    const I = e(t, S);
    setTimeout(() => {
      typeof n == "function" ? Promise.resolve(n({
        response: f,
        error: E,
        url: h,
        options: p
      })).then((A = {}) => {
        var o, c;
        m(l((o = A && A.url) !== null && o !== void 0 ? o : h, (c = A && A.options) !== null && c !== void 0 ? c : p));
      }) : m(l(h, p));
    }, I);
  }).then(g).catch((m) => {
    if (!i)
      throw m;
    return g(null, m);
  }) : f && a ? f : Promise.reject(E || new Error("Number of attempts exceeded."))));
  return l(h, p).then(g).catch((f) => {
    if (!i)
      throw f;
    return g(null, f);
  });
};
class nt extends Error {
  constructor(e, r) {
    super(e), this.name = "CreateCheckoutSessionFailed", this.cause = r;
  }
}
class it extends Error {
  constructor(e, r) {
    super(e), this.name = "CreatePortalSessionFailed", this.cause = r;
  }
}
class ct extends Error {
  constructor(e, r) {
    super(e), this.name = "GetSubscriptionsFailed", this.cause = r;
  }
}
class at extends Error {
  constructor(e, r) {
    super(e), this.name = "GetProductsFailed", this.cause = r;
  }
}
class lt extends Error {
  constructor() {
    super("Invalid platform"), this.name = "InvalidPlatform";
  }
}
const ut = "LOCALHOST", ht = "PROD", ft = "STG", R = {
  LOCALHOST: ut,
  PROD: ht,
  STG: ft
}, dt = "native", pt = "server", Et = "web", N = {
  NATIVE: dt,
  SERVER: pt,
  WEB: Et
}, _t = {
  [R.LOCALHOST]: "https://api.stg.occloud.io",
  [R.PROD]: "https://api.oddschecker.com",
  [R.STG]: "https://api.stg.occloud.io"
}, mt = {
  [R.LOCALHOST]: "https://api.stg.occloud.io",
  [R.PROD]: "https://api.oddschecker.com",
  [R.STG]: "https://api.stg.occloud.io"
};
function Tt(t, e) {
  if (e === N.NATIVE || e === N.WEB)
    return _t[t];
  if (e === N.SERVER)
    return mt[t];
  throw new lt();
}
const T = class T {
  /**
   * Constructor for SubscriptionsSDK class.
   *
   * @param {SDKConstructorParams<T>} params - The SDK constructor params.
   */
  constructor({
    apiHost: e,
    apiKey: r,
    authToken: s,
    deviceId: n,
    environment: i,
    maxRetryAttempts: a = 3,
    platform: u
  }) {
    /**
     * The Wretch instance for making API requests.
     *
     * @property apiClient
     * @type {Wretch}
     */
    y(this, "apiClient");
    /** The MyOC auth token
     *
     * @property authToken
     * @type {string}
     */
    y(this, "authToken");
    /** The MyOC device ID
     *
     * @property deviceId
     * @type {string}
     */
    y(this, "deviceId");
    const l = e ?? Tt(i, u);
    this.apiClient = this.initApiClient(l, a, r), this.authToken = s, this.deviceId = n;
  }
  initApiClient(e, r, s) {
    return P().addon(X()).addon($).middlewares([
      et(),
      ot({
        delayTimer: 100,
        delayRamp: (n, i) => n * i,
        maxAttempts: r,
        resolveWithLatestResponse: !0
      })
    ]).url(e).headers({
      ...T.DEFAULT_HEADERS,
      "API-KEY": s
    });
  }
  /**
   * Creates a checkout session for the specified product.
   *
   * @param {CheckoutOptions} options - The checkout options.
   * @param {string} [options.authToken] - The auth token.
   * @param {string} [options.affiliateId] - The affiliate ID.
   * @param {string} [options.couponCode] - The coupon code.
   * @param {string} [options.customerLocale] - The customer locale.
   * @param {string} [options.deviceId] - The device ID.
   * @param {string} options.priceId - The price ID.
   * @param {Provider} [options.provider] - The provider.
   * @param {number} [options.quantity] - The quantity.
   * @param {number} [options.trialDays] - The trial days.
   * @param {ProductType} [options.type] - The product type.
   * @param {Object} [options.urls] - The checkout URLs.
   * @param {string} [options.urls.cancelUrl] - The cancel URL.
   * @param {string} [options.urls.successUrl] - The success URL.
   * @returns {Promise<string | never>} The checkout session URL.
   */
  async createCheckoutSession({
    affiliateId: e,
    authToken: r,
    couponCode: s,
    customerLocale: n = "EN",
    deviceId: i,
    priceId: a,
    provider: u = "STRIPE",
    quantity: l = 1,
    trialDays: h,
    type: p,
    urls: S
  }) {
    const { cancelUrl: g, successUrl: f } = S;
    try {
      const { url: E } = await this.apiClient.url(T.ENDPOINT_CHECKOUT_SESSIONS).headers({
        Authorization: r ?? this.authToken,
        "Device-ID": i ?? this.deviceId
      }).post({
        affiliateId: e,
        cancelUrl: g,
        couponCode: s,
        customer: {
          locale: n
        },
        items: [
          {
            priceId: a,
            quantity: l,
            trialDays: h,
            type: p
          }
        ],
        provider: u,
        successUrl: f
      }).setTimeout(1e3).json();
      return E;
    } catch (E) {
      let O = "An error occurred while creating checkout session";
      throw E instanceof Error && (O = E.message), new nt(O, E);
    }
  }
  /**
   * Creates a portal session
   * @param {PortalSessionOptions} options - The portal session options.
   * @param {string} [options.authToken] - The auth token.
   * @param {string} [options.customerLocale] - The customer locale.
   * @param {string} [options.deviceId] - The device ID.
   * @param {string} [options.returnUrl] - The return URL.
   * @returns {Promise<string | never>} The portal session URL.
   */
  async createPortalSession({
    authToken: e,
    customerLocale: r = "EN",
    deviceId: s,
    returnUrl: n
  }) {
    try {
      const { url: i } = await this.apiClient.url(T.ENDPOINT_PORTAL_SESSIONS).headers({
        Authorization: e ?? this.authToken,
        "Device-ID": s ?? this.deviceId
      }).post({
        returnUrl: n,
        customer: {
          locale: r
        }
      }).setTimeout(1e3).json();
      return i;
    } catch (i) {
      let a = "An error occurred while creating portal session";
      throw i instanceof Error && (a = i.message), new it(a, i);
    }
  }
  /**
   * Gets the products for the specified product type.
   *
   * @param {boolean} [includeArchived] - Whether to include archived products.
   * @returns {Promise<Product[] | never>} The products.
   */
  async getProducts(e) {
    try {
      const { products: r } = await this.apiClient.url(T.ENDPOINT_PRODUCTS).query(e ? { includeArchived: !0 } : {}).options({
        signal: AbortSignal.timeout(1e4)
      }).get().setTimeout(1e3).json();
      return r;
    } catch (r) {
      let s = "An error occurred while getting products";
      throw r instanceof Error && (s = r.message), new at(s, r);
    }
  }
  /**
   * Gets the subscriptions for the current user.
   *
   * @param {GetSubscriptionsOptions} options - The get subscriptions options.
   * @param {string} [options.authToken] - The auth token.
   * @param {string} [options.deviceId] - The device ID.
   * @returns {Promise<UserSubscription[] | never>} The user's subscriptions.
   */
  async getSubscriptions({
    authToken: e,
    deviceId: r
  } = {}) {
    try {
      const { subscriptions: s } = await this.apiClient.url(T.ENDPOINT_SUBSCRIPTIONS).headers({
        Authorization: e ?? this.authToken,
        "Device-ID": r ?? this.deviceId
      }).options({
        signal: AbortSignal.timeout(1e4)
      }).get().setTimeout(1e3).json();
      return s;
    } catch (s) {
      let n = "An error occurred while getting subscriptions";
      throw s instanceof Error && (n = s.message), new ct(n, s);
    }
  }
};
/**
 * Default headers for the API requests.
 */
y(T, "DEFAULT_HEADERS", {
  Accept: "application/json",
  "Content-Type": "application/json"
}), /**
 * Endpoint for creating a checkout session.
 *
 * @property ENDPOINT_CHECKOUT_SESSIONS
 * @type {string}
 * @default
 */
y(T, "ENDPOINT_CHECKOUT_SESSIONS", "/v1/checkout/sessions"), /**
 * Endpoint for creating a portal session.
 *
 * @property ENDPOINT_PORTAL_SESSIONS
 * @type {string}
 * @default
 */
y(T, "ENDPOINT_PORTAL_SESSIONS", "/api/v1/myoddschecker/subscriptions/manage/sessions"), /**
 * Endpoint for getting products.
 *
 * @property ENDPOINT_PRODUCTS
 * @type {string}
 * @default
 */
y(T, "ENDPOINT_PRODUCTS", "/v1/products"), /**
 * Endpoint for getting a user's subscriptions.
 *
 * @property ENDPOINT_SUBSCRIPTIONS
 * @type {string}
 * @default
 */
y(T, "ENDPOINT_SUBSCRIPTIONS", "/api/v2/myoddschecker/subscriptions");
let U = T;
export {
  nt as CreateCheckoutSessionFailed,
  it as CreatePortalSessionFailed,
  at as GetProductsFailed,
  ct as GetSubscriptionsFailed,
  lt as InvalidPlatformError,
  U as SubscriptionsSDK
};
